export interface IInjectable {
    $inject: string[];
}

export type DirectiveControllerConstructor = Function & IInjectable;

export abstract class BaseDirective implements ng.IDirective {
    restrict: string;
    replace: boolean = false;
    template: string | ((tElement: JQuery, tAttrs: ng.IAttributes) => string) = "";
    controller: any;
    controllerAs: string;
    bindToController: boolean = false;
    classes: Array<string> = [];
    scope = {};

    link = (_scope: ng.IScope, _element: ng.IAugmentedJQuery, attr: ng.IAttributes, controller: any) => {
        if (this.classes.length > 0) this.classes.forEach(c => attr.$addClass(c));
    };

    static $inject: string[] = [];
    constructor(controller: DirectiveControllerConstructor) {
        this.controller = controller;
        this.controllerAs = "vm";
        this.restrict = "EA";
    }
}

export const directiveFactory = (directive: any) => {
    const _directive = (...arg: any[]) => {
        return new directive(...arg);
    };
    (_directive as any).$inject = directive.$inject;

    return _directive;
};

export const serviceFactory = (service: any) => {
    return [...service.$inject, service];
};

export const interceptorFactory = (interceptor: any) => {
    const _interceptor = (...arg: any[]) => {
        return new interceptor(...arg);
    };
    (_interceptor as any).$inject = interceptor.$inject;

    return _interceptor;
};

export type IScopeBoundController<T extends Record<string, string>> = ng.IController & {
    [scopeProperty in keyof T]: unknown;
};
